import config from '@/config';

const baseUrl = `${config.host}/excel`;

export const exportFile = {
	exportAnswer(surveyId, startTime = '', endTime = '', activityTitle = '', platformOrigin) {
		console.log(666, platformOrigin);
		let url = `${baseUrl}/shop/survey/export?surveyId=${surveyId}`;
		if (startTime) {
			url += `&startTime=${startTime / 1000}`;
		}
		if (endTime) {
			url += `&endTime=${endTime / 1000}`;
		}
		if (activityTitle) {
			url += `&activityTitle=${activityTitle}`;
		}
		if (platformOrigin === 0 || platformOrigin === 1) {
			url += `&platformOrigin=${platformOrigin}`;
		}
		return url;
	},
};
